define('widgets/casumoHoldingValuables/viewmodel',['knockout'], function (ko) {

    var CasumoHoldingValuables = function () {};

    CasumoHoldingValuables.prototype.activate = function (settings) {
        this.valuables = settings.valuables || ko.observable([]);

        this.width = ko.pureComputed(function () {
            var settingsWidth = ko.unwrap(settings.width),
                settingsHeight = ko.unwrap(settings.height),
                width = '100%';

            if (settingsWidth) {
                width = settingsWidth + 'px';
            }

            else if (settingsHeight) {
                // if the ui is interested in the height then calculate width from the aspect ratio
                width = settingsHeight / 140 * 100 + 'px';
            }

            return width;

        });
    };

    CasumoHoldingValuables.prototype.attached = function (view, parent) {
        parent.classList.add('casumo-holding-valuables-container');
    };

    return CasumoHoldingValuables;
});

